export default {
  strict: true,
  namespaced: true,
  state: {
    edit: {
      details: {
        tripInfo: {
          id: '',
          brandId: '',
          brand: '',
          brandColor: '',
          packageId: '',
          bookedThrough: '',
          status: '',
          bidId: '',
          bidStatus: '',
          created: '',
          pickupDate: '',
          fare: '',
          driverPayment: '',
          driverBonus: '',
          paymentBonus: '',
          gasFee: '',
          tip: '',
          pickupFee: '',
          credits: '',
          serviceType: '',
          serviceLabel: '',
          serviceCode: '',
          pickup: '',
          dropoff: '',
          beThereTime: '',
          aptGate: '',
          eta: '',
          distance: '',
          isAsap: false,
          airline: '',
          airlineCode: '',
          airportCode: '',
          isAirportPickup: false,
          isAirportDropoff: false,
          flightNo: '',
          passenger: '',
          luggage: '',
          notes: '',
          serviceArea: '',
          wheelchair: '',
          serviceDog: '',
          overridePrice: '',
          overridePayment: '',
          extraStops: [],
          isCharter: false
        },
        customerInfo: {
          id: '',
          firstName: '',
          lastName: '',
          creditCard: '',
          cardTitle: '',
          creditCardId: '',
          email: '',
          mobile: '',
          corpConsId: '',
        },
        guestInfo: {
          firstName: '',
          lastName: '',
          mobile: ''
        }
      },
      serviceLoading: false,
      selectedService: '',
      services: {
        shared: {},
        opoli: {},
        black: {},
        suv: {},
        shuttle: {}
      },
      holiday: {
        date: '',
        shared: {
          currency: '',
          value: ''
        },
        opoli: {
          currency: '',
          value: ''
        },
        black: {
          currency: '',
          value: ''
        },
        suv: {
          currency: '',
          value: ''
        },
        shuttle: {
          currency: '',
          value: ''
        }
      },
      timezoneLoading: false,
      timezone: 'America/Los_Angeles',
      isSaving: false,
      showUpdateReturn: {
        show: false,
        message: '',
        status: ''
      },
      suggestedTime: {
        show: false,
        time: '',
        isDomestic: ''
      },
      lastFlightNo: '',
      currency: {
        code: 'USD',
        symbol: '$',
        value: 1,
        original: {
          code: 'USD',
          symbol: '$',
          value: 1,
        }
      }
    },
    isManualTip: false,
    updateMap: false
  },
  mutations: {
    setEditData(state, value) { state.edit.details = value },
    setServiceLoading(state, value) { state.edit.serviceLoading = value },
    setSelectedService(state, value) { state.edit.selectedService = value },
    addService(state, data) { state.edit.services[data.code] = data.value },
    setServices(state, value) { state.edit.services = value },
    setHoliday(state, value) { state.edit.holiday = value },
    setTimezoneLoading(state, value) { state.edit.timezoneLoading = value },
    setTimezone(state, value) { state.edit.timezone = value },
    setIsSaving(state, value) { state.edit.isSaving = value },
    setShowUpdateReturn(state, value) { state.edit.showUpdateReturn = value },
    setPickup(state, value) { state.edit.details.tripInfo.pickup = value },
    setDropoff(state, value) { state.edit.details.tripInfo.dropoff = value },
    setPickupGeofence(state, value) {
      if (value.id) {
        state.edit.details.tripInfo.pickup.geofenceId = value.id
      }
      state.edit.details.tripInfo.pickup.geofenceName = value.name
      state.edit.details.tripInfo.pickup.geofenceType = value.type
    },
    setDropoffGeofence(state, value) {
      if (value.id) {
        state.edit.details.tripInfo.dropoff.geofenceId = value.id
      }
      state.edit.details.tripInfo.dropoff.geofenceName = value.name
      state.edit.details.tripInfo.dropoff.geofenceType = value.type
    },
    setPickupDate(state, value) { state.edit.details.tripInfo.pickupDate = value },
    setIsAsap(state, value) { state.edit.details.tripInfo.isAsap = value },
    setIsAirportPickup(state, value) { state.edit.details.tripInfo.isAirportPickup = value },
    setIsAirportDropoff(state, value) { state.edit.details.tripInfo.isAirportDropoff = value },
    setAirportCode(state, value) { state.edit.details.tripInfo.airportCode = value },
    setAirline(state, value) {
      state.edit.details.tripInfo.airline = value.airline
      state.edit.details.tripInfo.airlineCode = value.airlineCode
    },
    setFlightNo(state, value) { state.edit.details.tripInfo.flightNo = value },
    setDistanceEta(state, value) {
      state.edit.details.tripInfo.distance = value.distance
      state.edit.details.tripInfo.eta = value.eta
    },
    setSuggestedTimeShow(state, value) { state.edit.suggestedTime.show = value },
    setSuggestedTime(state, value) { state.edit.suggestedTime.time = value },
    setSuggestedTimeIsDomestic(state, value) { state.edit.suggestedTime.isDomestic = value },
    setLastFlightNo(state, value) { state.edit.lastFlightNo = value },
    setPassenger(state, value) { state.edit.details.tripInfo.passenger = value },
    setLuggage(state, value) { state.edit.details.tripInfo.luggage = value },
    setCustomerInfo(state, data) {
      state.edit.details.customerInfo.id = data.id
      state.edit.details.customerInfo.firstName = data.firstName
      state.edit.details.customerInfo.lastName = data.lastName
      state.edit.details.customerInfo.email = data.email
      state.edit.details.customerInfo.mobile = data.mobile
      state.edit.details.customerInfo.countryCode = data.countryCode
      state.edit.details.customerInfo.nationalNumber = data.nationalNumber
      state.edit.details.customerInfo.corpConsId = 0
      if (data.consId) {
        state.edit.details.customerInfo.corpConsId = data.consId
      }
    },
    setGasFee(state, value) { state.edit.details.tripInfo.gasFee = value },
    setTip(state, value) { state.edit.details.tripInfo.tip = value },
    setpaymentBonus(state, value) { state.edit.details.tripInfo.paymentBonus = value },
    setIsManualTip(state, value) { state.isManualTip = value },
    // setExtraStop (state, data) {
    //   state.edit.details.tripInfo.extraStops = value
    // }
    addExtraStop (state, value) {
      state.edit.details.tripInfo.extraStops.push(value)
    },
    setExtraStopData (state, data) {
      let index = state.edit.details.tripInfo.extraStops.findIndex(x => x.id === data.id)
      let hasMapUpdate = false
      if (index > -1) {
        for (let field in data.fields) {
          state.edit.details.tripInfo.extraStops[index][field] = data.fields[field]
          if (['lat', 'lng'].indexOf(field) > -1) {
            hasMapUpdate = true
          }
        }
        if (hasMapUpdate) {
          state.updateMap = true
        }
      }
    },
    removeExtraStop (state) {
      state.edit.details.tripInfo.extraStops = []
    },
    setUpdateMap (state, value) {
      state.updateMap = value
    },
    setEditCurrency (state, data) {
      for (let field in data) {
        state.edit.currency[field] = data[field]
      }
    },
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/edit.js